import React, { useContext, useEffect } from 'react';
import { GlobalContext } from '@mummssoftware/global-context/GlobalContext';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import { STRING_FALSE, STRING_TRUE } from '@mummssoftware/utils/constants';
import { VisitContext } from '../Context/contexts/VisitContext';
import { SET_FACE_TO_FACE } from '../Context/constants';
import defaults from '../../translations/en.json';
import { useStyles } from './style';

export const FaceToFace = () => {
  const classes = useStyles();
  const { dispatchVisit, editFaceToFace } = useContext(VisitContext);
  const { appVisit } = useContext(GlobalContext);

  useEffect(() => {
    if (appVisit) {
      const { facetofacevisit } = appVisit as any;

      if (facetofacevisit) {
        dispatchVisit({
          type: SET_FACE_TO_FACE,
          payload: true,
        });
      }
    }
  }, [appVisit]);

  const onFaceToFaceChange = (event: any) => {
    const boolVal = event.target.value === STRING_TRUE;
    dispatchVisit({
      type: SET_FACE_TO_FACE,
      payload: boolVal,
    });
  };
  return (
    <>
      <FormControl
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '1vw',
        }}
      >
        <FormLabel classes={{ root: classes.label }}>
          {defaults.faceToFaceToggle}
        </FormLabel>
        <RadioGroup
          value={String(editFaceToFace)}
          onChange={onFaceToFaceChange}
          row
        >
          <FormControlLabel
            value={STRING_TRUE}
            control={<Radio size="small" />}
            label={defaults.yes}
            classes={{ label: classes.radioLabel }}
          />
          <FormControlLabel
            value={STRING_FALSE}
            control={<Radio size="small" />}
            label={defaults.no}
            classes={{ label: classes.radioLabel }}
          />
        </RadioGroup>
      </FormControl>
    </>
  );
};
